module.exports = __webpack_public_path__ + "static/img/1.WebpayOneclick_FB_800px.858194e6.svg";